module.exports = __webpack_public_path__ + "img/01_backplate.6e84084a.jpg";